import { render, staticRenderFns } from "./holidays.vue?vue&type=template&id=3e77f8c6&scoped=true"
import script from "./holidays.vue?vue&type=script&lang=js"
export * from "./holidays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e77f8c6",
  null
  
)

export default component.exports